module.exports = __webpack_public_path__ + "img/cc-mbs-square-white.4e1d6b4a.png";